<template>
  <!-- 拜访详情 -->
  <div class="visit-detail">
    <!-- 拜访信息头部 -->
    <div class="visit-info-header">
      <div class="info-row doctor-name">
        <span class="info-label">拜访医生</span>
        <el-tag
          type="info"
          effect="plain"
          size="small"
          @click="nameClickHandle(currentClueInfo)"
        >{{ currentClueInfo.doctorName || '' }}</el-tag>
      </div>
      <div class="info-row">
        <span class="info-label">时间范围</span>
        <span class="info-value">{{ visitInfo.startDate }} 至 {{ visitInfo.endDate }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">拜访次数</span>
        <div class="visit-counts">
          <div class="visit-counts-item">
            <el-tag type="primary" size="small">
              <i class="el-icon-location"></i>现场
            </el-tag>
            <span class="count">{{ currentClueInfo.siteVisitCount || 0 }}次</span>
          </div>
          <div class="visit-counts-item">
            <el-tag type="success" size="small">
              <i class="el-icon-chat-dot-round"></i>微信
            </el-tag>
            <span class="count">{{ currentClueInfo.wechatVisitCount || 0 }}次</span>
          </div>
          <div class="visit-counts-item">
            <el-tag type="warning" size="small">
              <i class="el-icon-phone"></i>电话
            </el-tag>
            <span class="count">{{ currentClueInfo.phoneVisitCount || 0 }}次</span>
          </div>
        </div>
      </div>
      <div class="info-row">
        <span class="info-label">跟进人</span>
        <span class="info-value">{{ currentClueInfo.workName || '' }}</span>
      </div>
    </div>

    <!-- 拜访记录时间线 -->
    <div class="visit-timeline">
      <div
        v-for="(record, index) in visitList.reverse()"
        :key="index"
        class="timeline-item"
        :class="{ 'is-last': index === visitList.length - 1 }"
      >
        <!-- 时间线左侧：节点 + 连接线 -->
        <div class="timeline-rail">
          <div class="timeline-dot">
            <div
              class="timeline-dot-content"
              :style="{ backgroundColor: getTimelineColor(record.type) }"
            ></div>
          </div>
          <div v-if="index !== visitList.length - 1" class="timeline-line"></div>
        </div>

        <!-- 时间线右侧：内容卡片 -->
        <div class="timeline-content">
          <div class="timeline-card">
            <!-- 卡片头部：类型标签 + 时间 -->
            <div class="card-header">
              <span
                class="type-tag"
                :class="'type-' + getTagType(record.visitType)"
              >
                <i :class="getTypeIcon(record.visitType)"></i>
                <span>{{ record.visitTypeText || '' }}</span>
              </span>
              <span class="card-time">
                <i class="el-icon-time"></i>
                {{ record.createTimeText || '' }}
              </span>
            </div>

            <!-- 医生需求 -->
            <div class="card-section">
              <div class="section-label">医生需求</div>
              <div class="section-content doctor-need">{{ record.feedback || '' }}</div>
            </div>

            <!-- 现场图片（仅现场拜访显示） -->
            <div v-if="Number(record.visitType) === 1 && record.picture && record.picture.length > 0" class="card-section">
              <div class="section-label">现场图片</div>
              <div class="image-list">
                <el-image
                  v-for="(img, imgIndex) in record.picture"
                  :key="imgIndex"
                  :src="img"
                  :preview-src-list="record.picture"
                  class="visit-image"
                  fit="cover"
                />
              </div>
            </div>

            <!-- 费用明细 -->
            <div class="card-section">
              <div class="section-label">费用明细</div>
              <div class="section-content">
                <div v-if="record.visitFee > 0" class="cost-summary">
                  总费用 <b>{{ record.visitFee || 0 }}元</b>
                  <span v-if="record.feedDetail" class="cost-detail"> | {{ record.feedDetail || '' }}</span>
                </div>
                <div v-else class="no-cost">无费用</div>
              </div>
            </div>

            <!-- 附件 -->
            <div v-if="record.attr && record.attr.length > 0" class="card-section">
              <div class="section-label">附件</div>
              <div class="image-list">
                <el-image
                  v-for="(img, imgIndex) in record.attr"
                  :key="imgIndex"
                  :src="img"
                  :preview-src-list="record.attr"
                  class="visit-image"
                  fit="cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
  import request from '@/utils/request'
  export default {
    name: 'VisitDetail',
    props: {
      currentClueInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        visitInfo: {
          startDate: '',
          endDate: ''
        },
        // 拜访记录列表
        visitList: []
      }
    },
    computed: {
      imageBaseUrl() {
        return process.env.VUE_APP_ENV === 'production' ? 'https://image.scxinglin.com' : 'https://testdev.scxinglin.com'
      }
    },
    methods: {
      // 获取详情信息
      async getClueDetail() {
        const params = {
          doctorStageId: this.currentClueInfo.doctorStageId || '',
          doctorId: this.currentClueInfo.doctorId || ''
        }
        try {
          const res = await request.get('/cluepool/pc/doctor/queryDoctorExtend', params, '')
          if (res.code === 200) {
            const data = res.data || {}
            const visitTypeInfo = {
              '1': '现场拜访',
              '2': '微信拜访',
              '3': '电话拜访',
              '4': '家访',
              '5': '宴请',
              '6': '跟诊'
            }

            const visitList = (data.visits || [])
              .filter(item => item.workNumber === this.currentClueInfo.workNumber)
              .sort((a, b) => (a.createTime || 0) - (b.createTime || 0))
              .map(item => ({
                ...item,
                picture: item.picture ? item.picture.split(',').map(item => this.imageBaseUrl + item) : [],
                attr: item.attr ? item.attr.split(',').map(item => this.imageBaseUrl + item) : [],
                visitTypeText: visitTypeInfo[item.visitType] || '',
                createTimeText: item.createTime ? new Date(item.createTime).Format('yyyy-MM-dd hh:mm:ss').slice(0, 16) : ''
              }))
            if (visitList.length > 0) {
              this.visitInfo.startDate = (visitList[0].createTimeText || '').slice(0, 10)
              this.visitInfo.endDate = (visitList[visitList.length - 1].createTimeText || '').slice(0, 10)
            }
            this.visitList = visitList
          } else {
            this.$message.error(res.message || '获取线索详情失败')
          }
        } catch (error) {
          console.log('获取线索详情失败', error)
        }
      },
      nameClickHandle(data) {
        this.$emit('nameClick', data)
      },
      // 获取时间线颜色
      getTimelineColor(type) {
        const colorMap = {
          '1': '#1890FF',
          '2': '#52C41A',
          '3': '#FAAD14'
        }
        return colorMap[type] || '#D9D9D9'
      },
      // 获取标签类型
      getTagType(type) {
        const typeMap = {
          '1': 'primary',
          '2': 'success',
          '3': 'warning'
        }
        return typeMap[type > 3 ? '1' : type] || 'info'
      },
      // 获取类型图标
      getTypeIcon(type) {
        const iconMap = {
          '1': 'el-icon-location',
          '2': 'el-icon-chat-dot-round',
          '3': 'el-icon-phone'
        }
        return iconMap[type > 3 ? '1' : type] || ''
      }
    },
    mounted() {
      this.getClueDetail()
    }
  }
 
</script>

<style scoped lang='less'>
.visit-detail {
  padding: 0 20px;
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  background-color: #FAFBFC ;

  // 拜访信息头部
  .visit-info-header {
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 10px;

    .info-row {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 13px;

      &.doctor-name {
        /deep/ .el-tag--plain.el-tag--info {
          background-color: #F4F8FB;
          border-color: #EBEAEE;
          color: #667182;
          height: 24px;
          line-height: 22px;
          padding: 0 10px;
          border-radius: 12px;
          cursor: pointer;

          &:hover {
            border-color: #1890FF;
            color: #1890FF;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      .info-label {
        width: 80px;
        color: #9AA0A8;
        flex-shrink: 0;
      }

      .info-value {
        color: #1F2329;
        font-weight: 500;
      }

      .visit-counts {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;

        .visit-counts-item {
          display: flex;
          align-items: center;
          gap: 4px;

          span.count {
            font-size: 14px;
            letter-spacing: 1px;
          }
        }

        /deep/ .el-tag {
          display: flex;
          align-items: center;
          gap: 4px;
          i {
            font-size: 12px;
          }
        }
      }
    }
  }

  // 拜访记录时间线
  .visit-timeline {
    .timeline-item {
      display: flex;
      align-items: stretch;
      position: relative;

      &.is-last .timeline-content {
        padding-bottom: 0;
      }
    }

    // 左侧时间线节点 + 连接线
    .timeline-rail {
      position: relative;
      top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 24px;
      flex-shrink: 0;

      .timeline-dot {
        position: relative;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        flex-shrink: 0;
        z-index: 2;
        background-color: #fff;
        box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.1);

        .timeline-dot-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
      }

      .timeline-line {
        flex: 1;
        width: 1px;
        background-color: #E8E8E8;
        margin-top: 4px;
      }
    }

    // 右侧内容区
    .timeline-content {
      flex: 1;
      min-width: 0;
      padding-bottom: 20px;
    }

    .timeline-card {
      background-color: #FFF;
      border: 1px solid #E8E8E8;
      border-radius: 4px;
      box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.1);

      // 卡片头部
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #EBEAEE;

        .type-tag {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          height: 24px;
          padding: 0 10px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
          line-height: 1;

          i {
            font-size: 12px;
          }

          &.type-primary {
            background-color: #E6F4FF;
            color: #1890FF;
          }

          &.type-success {
            background-color: #E2F8E0;
            color: #29C01B;
          }

          &.type-warning {
            background-color: #FFF3D6;
            color: #FAAD14;
          }
        }

        .card-time {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
          color: #9AA0A8;

          i {
            font-size: 13px;
          }
        }
      }

      .card-section {
        padding: 12px 16px 6px;

        &:last-child {
          margin-bottom: 0;
          padding-bottom: 16px;
        }

        .section-label {
          font-size: 12px;
          color: #9AA0A8;
          margin-bottom: 8px;
        }

        .section-content {
          font-size: 13px;
          color: #1F2329;
          line-height: 1.6;

          &.doctor-need {
            background-color: #FAFAFA;
            padding: 10px 12px;
            border-radius: 4px;
            border-left: 3px solid #1890FF;
          }

          .cost-summary {
            b {
              color: #1890FF;
              font-weight: 600;
            }

            .cost-detail {
              color: #667182;
              font-size: 12px;
            }
          }

          .no-cost {
            font-size: 13px;
          }
        }

        .image-list {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;

          .visit-image {
            width: 80px;
            height: 80px;
            border-radius: 4px;
            cursor: pointer;
          }
        }

        .attachment-link {
          color: #1890FF;
          cursor: pointer;
          font-size: 13px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>